import { ApiError } from '../../lib/call.ts';

export function Loading({ label = '불러오는 중' }: { label?: string }) {
  return <p className="p-6 text-sm text-slate-500">{label}…</p>;
}

export function ErrorBox({ error }: { error: unknown }) {
  if (error instanceof ApiError && error.status === 404) {
    return (
      <p className="rounded-md border border-slate-200 bg-white p-6 text-sm text-slate-600">
        찾을 수 없거나 볼 수 있는 범위 밖입니다.
      </p>
    );
  }
  const message = error instanceof Error ? error.message : String(error);
  return <p className="rounded-md border border-red-200 bg-red-50 p-4 text-sm text-red-800">{message}</p>;
}

export function Empty({ children }: { children: string }) {
  return <p className="p-6 text-center text-sm text-slate-500">{children}</p>;
}
